export default "__VITE_ASSET__BRqx3SKU__"